module.exports = __webpack_public_path__ + "media/images/brand-assets/light_1-0451de21476e8c6f9cfb8c2a1f8b590d.png";